﻿export class DataRequestStarted {
    static eventName() { return 'DataRequestStarted' }

    eventName = DataRequestStarted.eventName;
}